import { applyMiddleware, createStore, combineReducers } from 'redux';
import { createLogger } from 'redux-logger';
import thunk from 'redux-thunk';
import promise from 'redux-promise-middleware';

import app from './appReducer';
import auth from "./authReducer";
import classroom from './classroomReducer';
import classroomMessage from './classroomMessageReducer';
import course from './courseReducer';
import enrollmentRequest from './enrollmentRequestReducer';
import material from './materialReducer';
import message from './messageReducer';
import section from './sectionReducer';
import profile from './profileReducer';

const createAppStore = (initialState = {}) => {
    const reducer =  combineReducers({
        app,
        auth,
        classroom,
        classroomMessage,
        course,
        enrollmentRequest,
        material,
        message,
        profile,
        section,
    });

    const middleware = applyMiddleware(promise, thunk, createLogger());

    return createStore(reducer, initialState, middleware);
};

export default createAppStore;
